import React from "react";
import Countdown from "react-countdown";
import { Link } from 'react-router-dom';
import ReactCountryFlag from "react-country-flag";

const Card02 = ({
    item,
    showStyle = 'rect',
    index
}) => {

    return (
        <>
            <div className={`sc-card-product ${showStyle === 'penta' ? 'market-card' : ''}`}>
                <div className="card-media">
                    {
                    showStyle == 'penta' ? 
                    <svg viewBox="0 0 193 184" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M102.084 181.325C98.7543 183.744 94.2457 183.744 90.916 181.325L5.18846 119.04C1.85881 116.621 0.465576 112.333 1.73737 108.419L34.4824 7.64009C35.7542 3.72588 39.4018 1.07576 43.5174 1.07576L149.483 1.07576C153.598 1.07576 157.246 3.72588 158.518 7.64011L191.263 108.419C192.534 112.333 191.141 116.621 187.812 119.04L102.084 181.325Z" fill="url(#paint0_linear_45_270)"/>
                        <path d="M102.084 181.325C98.7543 183.744 94.2457 183.744 90.916 181.325L5.18846 119.04C1.85881 116.621 0.465576 112.333 1.73737 108.419L34.4824 7.64009C35.7542 3.72588 39.4018 1.07576 43.5174 1.07576L149.483 1.07576C153.598 1.07576 157.246 3.72588 158.518 7.64011L191.263 108.419C192.534 112.333 191.141 116.621 187.812 119.04L102.084 181.325Z" fill={`url(#pattern${index})`}/>
                        <path d="M102.084 181.325C98.7543 183.744 94.2457 183.744 90.916 181.325L5.18846 119.04C1.85881 116.621 0.465576 112.333 1.73737 108.419L34.4824 7.64009C35.7542 3.72588 39.4018 1.07576 43.5174 1.07576L149.483 1.07576C153.598 1.07576 157.246 3.72588 158.518 7.64011L191.263 108.419C192.534 112.333 191.141 116.621 187.812 119.04L102.084 181.325Z" stroke="#767676"/>
                        <defs>
                            <pattern id={`pattern${index}`} patternContentUnits="objectBoundingBox" width="1" height="1">
                            <use xlinkHref={`#image${index}_45_270`} transform="matrix(-0.00365 0 0 0.00355 1.25 -0.11)"/>
                            </pattern>
                            <linearGradient id="paint0_linear_45_270" x1="96.5" y1="186" x2="96.5" y2="-19" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#D9D9D9"/>
                            <stop offset="1" stopColor="#D9D9D9" stopOpacity="0"/>
                            </linearGradient>
                            <image id={`image${index}_45_270`} width="325" height="345" style={{transform: 'scaleX(-1)', transformOrigin: 'right'}} xlinkHref={item.avatar} />
                        </defs>
                    </svg>
                    :
                    <img src={item.avatar} alt={item.alias} />
                    }

                </div>

                <div className="detail-info d-flex">
                    <div className="nation-flag">
                        <ReactCountryFlag
                            countryCode={item.country}
                            svg
                            style={{
                                height: '48px',
                                width: 'unset',
                                borderRadius: '7px',
                                border: '1px solid #929292'
                            }}
                            title={item.country}
                        />
                    </div>
                    <div className="meta-info-wrapper">
                        <div className="meta-info-name text-left">
                            {item.alias}
                        </div>
                        <div className="meta-info-interest text-left">
                            {item.interest}
                        </div>
                    </div>
                </div>
                <div className="meta-info-description">
                    { item.description && item.description}
                </div>
            </div>  
        </>
    )
}

export default Card02;